/**
 * Modal functionality
 */

document.addEventListener('DOMContentLoaded', () => {
  const sizeGuideModal = document.querySelector('.size-table-section');
  const triggerButton = document.querySelector('.size-guide-modal__trigger');
  const closeButton = document.querySelector('.size-table-section .close-button');
  const openBookingModalButton = document.querySelector('.size-table-section .modal-trigger');

  function openModal() {
    sizeGuideModal.style.display = 'flex';
    setTimeout(() => {
      sizeGuideModal.style.opacity = 1;
    }, 100);
  }

  function closeModal() {
    sizeGuideModal.style.opacity = 0;
    setTimeout(() => {
      sizeGuideModal.style.display = 'none';
    }, 100);
  }

  if (!triggerButton && !closeButton) return;

  if (triggerButton) {
    triggerButton.addEventListener('click', openModal);
  }

  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  if (openBookingModalButton) {
    openBookingModalButton.addEventListener('click', closeModal);
  }

  window.addEventListener('click', (event) => {
    if (event.target === sizeGuideModal) {
      closeModal();
    }
  });
});

/**
 * Size guide functionality
 */

document.addEventListener('DOMContentLoaded', () => {
  const sizeSelect = document.querySelector('select[name="options[Size]"]');
  const rows = document.querySelectorAll('.table tbody tr');
  const sizeBoxes = document.querySelectorAll('.size-chart-container .size-chart-box');

  if (!sizeSelect || !rows.length) return;

  const updateUI = (selectedSize) => {
    highlightElements(rows, 'td.size-value', selectedSize);

    if (sizeBoxes && sizeBoxes.length) {
      highlightElements(sizeBoxes, '.size-chart-title', selectedSize);
    }
  };

  sizeSelect.addEventListener('change', () => updateUI(sizeSelect.value));
  rows.forEach((row) => {
    row.addEventListener('click', () => {
      const sizeValue = row.querySelector('td.size-value')?.getAttribute('data-sizevalue') || '';
      updateUI(sizeValue);
    });
  });

  if (sizeBoxes && sizeBoxes.length) {
    sizeBoxes.forEach((box) => {
      box.addEventListener('click', () => {
        const sizeTitle =
          box.querySelector('.size-chart-title')?.getAttribute('data-sizevalue') ||
          box.querySelector('.size-chart-title')?.textContent ||
          '';
        updateUI(sizeTitle);
      });
    });
  }

  // Initial update
  updateUI(sizeSelect.value);

  const sizeData = getSizeData();

  if (sizeData.productSizes.length) {
    renderSizeChart(sizeData);
  }
});

function getSizeData() {
  const metafieldsElement = document.querySelector('#product-metafields--sizes');
  let sizeData = {};

  if (metafieldsElement) {
    try {
      sizeData = JSON.parse(metafieldsElement.innerHTML);
    } catch (error) {
      console.log(error);
    }
  }

  sizeData = {
    measurementTips: {},
    productSizes: [],
    ...sizeData,
  };

  return sizeData;
}

function highlightElements(elements, selector, selectedValue) {
  elements.forEach((el) => {
    el.classList.remove('highlighted');
    const value =
      el.querySelector(selector)?.getAttribute('data-sizevalue') ||
      el.querySelector(selector)?.textContent ||
      el.getAttribute('data-sizevalue') ||
      '';
    if (value === selectedValue) {
      el.classList.add('highlighted');
    }
  });
}

function camelCaseToWords(str) {
  return str.split(/(?=[A-Z])/).join(' ');
}

function renderSizeChart(sizeData) {
  const measurementTipsObject = sizeData.measurementTips;

  const headingIcon = (heading) => {
    if (!measurementTipsObject || !measurementTipsObject[heading]) return '';

    return `
      <div class="tooltip" data-tooltip-content="${measurementTipsObject[heading]}">
      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="info-icon">
      <path d="M9.5 7.81546H11.5V5.81546H9.5M10.5 18.8155C6.09 18.8155 2.5 15.2255 2.5 10.8155C2.5 6.40546 6.09 2.81546 10.5 2.81546C14.91 2.81546 18.5 6.40546 18.5 10.8155C18.5 15.2255 14.91 18.8155 10.5 18.8155ZM10.5 0.81546C9.18678 0.81546 7.88642 1.07412 6.67317 1.57666C5.45991 2.07921 4.35752 2.81581 3.42893 3.74439C1.55357 5.61976 0.5 8.1633 0.5 10.8155C0.5 13.4676 1.55357 16.0112 3.42893 17.8865C4.35752 18.8151 5.45991 19.5517 6.67317 20.0543C7.88642 20.5568 9.18678 20.8155 10.5 20.8155C13.1522 20.8155 15.6957 19.7619 17.5711 17.8865C19.4464 16.0112 20.5 13.4676 20.5 10.8155C20.5 9.50224 20.2413 8.20188 19.7388 6.98863C19.2362 5.77537 18.4997 4.67298 17.5711 3.74439C16.6425 2.81581 15.5401 2.07921 14.3268 1.57666C13.1136 1.07412 11.8132 0.81546 10.5 0.81546ZM9.5 15.8155H11.5V9.81546H9.5V15.8155Z" fill="#CEC6B3"/>
      </svg>
      </div>
    `;
  };

  const headingArray = Object.keys(sizeData.productSizes[0].measurements);
  headingArray.unshift('size');

  console.log({ sizeData, headingArray });

  document.querySelector('.table_heading').innerHTML = `<tr>${headingArray
    .map(
      (heading) =>
        `<th><div class="table__heading">${camelCaseToWords(heading)} ${
          heading === 'size' ? '' : headingIcon(heading)
        }</div></th>`
    )
    .join('')}</tr>`;

  document.querySelector('.table').insertAdjacentHTML(
    'beforeend',
    sizeData.productSizes
      .map((sizeEntry) => {
        let row = '<tr>';
        headingArray.forEach((heading) => {
          const cellValue = heading === 'size' ? sizeEntry.size : sizeEntry.measurements[heading];
          row += `<td class="size-value" data-sizeValue="${cellValue}">${cellValue}</td>`;
        });
        row += '</tr>';
        return row;
      })
      .join('')
  );

  const sizeElements = document.querySelectorAll('td.size-value');
  const sizeToggles = document.querySelectorAll('.size-toggle');

  function convertSizes(unit) {
    sizeElements.forEach((sizeElement) => {
      const isSizeColumn = sizeElement.cellIndex === 0;
      if (isSizeColumn) return;

      const originalSizeValue = parseFloat(sizeElement.dataset.sizevalue || sizeElement.innerText);
      if (Number.isNaN(originalSizeValue)) return;

      sizeElement.innerText =
        unit === 'cm' ? originalSizeValue : (originalSizeValue * 0.39).toFixed(1);
    });
  }

  sizeToggles.forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      const unit = event.target.dataset.unit;
      convertSizes(unit);
      sizeToggles.forEach((toggle) => toggle.classList.remove('button--primary'));
      event.target.classList.add('button--primary');
    });
  });

  document.querySelector('.product-measurements').style.display = 'block';
}
